import { render, staticRenderFns } from "./CartRuleOverview.vue?vue&type=template&id=2f9e1238&scoped=true&"
import script from "./CartRuleOverview.vue?vue&type=script&lang=js&"
export * from "./CartRuleOverview.vue?vue&type=script&lang=js&"
import style0 from "./CartRuleOverview.vue?vue&type=style&index=0&id=2f9e1238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9e1238",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VChip,VDataTable,VDivider,VIcon,VSwitch})
